module.exports = __webpack_public_path__ + "static/media/screenshot02.3cb390fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/screenshot02.png
// module id = 184
// module chunks = 0